import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'cc-nav-group',
  templateUrl: './nav-group.component.html',
  styleUrls: ['./nav-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavGroupComponent {
  @Input() caption: string;
}
